"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LoginConsole_1 = require("./LoginConsole");
exports.default = LoginConsole_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/LoginConsole/index.js
// module id = 576
// module chunks = 8